import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOfferedProducts } from "../features/products/productsSlice";

// Returns the offer label (e.g. "20% OFF") if the product is in the
// offered-products list, otherwise null. The list is fetched once.
const useOfferedProduct = (productId) => {
  const dispatch = useDispatch();
  const offered = useSelector((state) => state.product.offeredProducts);

  useEffect(() => {
    dispatch(getOfferedProducts());
  }, [dispatch]);

  if (!productId) return null;

  const offer = offered?.find(
    (item) => Number(item?.product_id) === Number(productId),
  );
  if (!offer) return null;

  const amount = Number(offer?.discount);
  const isPercentage = offer?.Discount_Type?.name === "Percentage";
  const label = amount > 0 ? (isPercentage ? `${amount}% OFF` : `₹${amount} OFF`) : "OFFER";

  return { ...offer, label };
};

export default useOfferedProduct;
